enum RouteEndpointsCommon {
  HOME = '/',
  WILDCARD = '*',
  ERROR_404 = '/404',
  ERROR_500 = '/500',
}

export default RouteEndpointsCommon;
